import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { Procedure } from "./Procedure/Procedure.js";
import Logs from "./Logs/Logs_v2.js";
import Invoices from "./Invoices/Invoices";
import EVV_Reports from "../Reports_V2/EVV_Reports.js";
import EVV_NJ_RESEND from "./Resend/EVV_NJ_RESEND";
import EVV_NJ_SUBMISSION_REVIEW from "./evv_submission_review.js";
import EvvReadiness from "./EvvReadiness/EvvReadiness.js";

class EvvV1 extends React.Component {
  state = {
    key: "7", // Default to EVV Submissions
  };

  handleSelect = (event, key) => {
    this.setState({ key });
  };

  render() {
    const { key } = this.state;
    const { checkTokenExpiry, user, comp_id } = this.props;

    let renderComponent;
    switch (key) {
      case "0":
        renderComponent = <Logs checkTokenExpiry={checkTokenExpiry} user={user} comp_id={comp_id} />;
        break;
      case "1":
        renderComponent = <Procedure checkTokenExpiry={checkTokenExpiry} user={user} comp_id={comp_id} />;
        break;
      case "2":
        renderComponent = <Invoices checkTokenExpiry={checkTokenExpiry} user={user} comp_id={comp_id} />;
        break;
      case "3":
        renderComponent = <EVV_Reports {...this.props} activeSubKey={'evvReport'} />;
        break;
      case "6":
        renderComponent = <EVV_NJ_RESEND user={user} />;
        break;
      case "7":
        renderComponent = <EVV_NJ_SUBMISSION_REVIEW user={user} />;
        break;
      case "8":
        renderComponent = <EvvReadiness checkTokenExpiry={checkTokenExpiry} user={user} comp_id={comp_id} />;
        break;
      default:
        renderComponent = null;
    }

    return (
      <Box>
        {/* Horizontal Navigation */}
        <Tabs
          value={key}
          onChange={this.handleSelect}
          variant="scrollable"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            "& .Mui-selected": {
              backgroundColor: "#f0f0f0",
              fontWeight: "bold",
            },
          }}
        >
          <Tab value="7" label="EVV Submissions" />
          <Tab value="8" label="EVV Readiness" />
          <Tab value="0" label="EVV Activity" />
          <Tab value="1" label="EVV Procedure" />
          <Tab value="3" label="EVV Reports" />
        </Tabs>

        {/* Content Area */}
        <Box sx={{ p: 1 }}>{renderComponent}</Box>
      </Box>
    );
  }
}

export default EvvV1;